"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelect = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var languages_1 = require("utils/helpers/languages");
var BaseSelect_1 = require("../BaseSelect");
var LanguageSelect = function (props) { return (React.createElement(BaseSelect_1.BaseSelect, __assign({ options: languages_1.languageData, label: (0, translation_1.getLocalization)('management/reports/export/language'), labelClassName: "language-label", getOptionLabel: function (option) { return option.name; }, getOptionValue: function (option) { return option.code; }, isSearchable: false }, props))); };
exports.LanguageSelect = LanguageSelect;
